import { render, staticRenderFns } from "./Desk.vue?vue&type=template&id=e8caa8cc&scoped=true&"
import script from "./Desk.vue?vue&type=script&lang=ts&"
export * from "./Desk.vue?vue&type=script&lang=ts&"
import style0 from "./Desk.vue?vue&type=style&index=0&id=e8caa8cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8caa8cc",
  null
  
)

export default component.exports